import { useRef } from "react";
import { jsPDF } from "jspdf"; // Import jsPDF for PDF generation
import html2canvas from "html2canvas"; // Import html2canvas for rendering HTML as image
import pdf from "../../assets/images/landingpage/image.png";
// import logo from "../../assets/images/landingpage/Clinical_Visuals_Logo.webp";
// import pdficon from "../../assets/images/Pasted image.png"; // PDF Icon

const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const pdficon = VISUALIZE__URL + "Pasted image.webp";
const logo = VISUALIZE__URL + "Clinical_Visuals_Logo.webp";
interface ImageData {
  src: string;
  caption: string;
}

interface SectionData {
  images: ImageData[];
  name: string;
  message: string;
  caption: string;
  banner_img: string;
  text: string;
  address: string;
}

declare global {
  interface Window {
    generatePDF: () => void;
  }
}

const EmailTemplate = () => {
  const htmlRef = useRef<HTMLDivElement>(null);

  const data: SectionData[] = [
    {
      images: [
        { src: pdf, caption: "caption1" },
        { src: pdf, caption: "caption2" },
        { src: pdf, caption: "caption3" },
        { src: pdf, caption: "caption4" },
      ],
      name: "Name",
      message:
        "These images give an overview of Clinical study. We'll call shortly to discuss you should prioritize.These images give an overview of Clinical study. We'll call shortly to discuss you should prioritize.These images give an overview of Clinical study. We'll call shortly to discuss you should prioritize.",
      caption: "This is a caption for the first.",
      banner_img: pdf,
      text:
        "The content of this message (including your email address) has been stored by Clinical Visuals. This data will not be used by Clinical Visials for any purpose other than for reporting back to sender that this message has been delivered.",
      address:
        'This message was sent using the  <a href="https://clinicalvisuals.com" target="_blank">clinicalvisuals.com</a> website by: Location Name, State, District - Pincode',
    },
  ];

  const loadImages = (imageUrls: string[]) => {
    return Promise.all(
      imageUrls.map(
        (url) =>
          new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.onload = resolve;
            img.onerror = reject;
          })
      )
    );
  };

  const generateAndOpenPDF = async () => {
    const imageUrls = [
      pdf,
      logo,
      pdficon,
      ...data.flatMap((item) => item.images.map((img) => img.src)),
      ...data.map((item) => item.banner_img),
    ];

    try {
      await loadImages(imageUrls);

      const doc = new jsPDF();

      const emailContainer = document.querySelector(".email-container") as HTMLElement | null;
if (!emailContainer) return;

const canvas = await html2canvas(emailContainer);

      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 10, 10, 180, 250);

      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const newWindow = window.open(pdfUrl, "_blank");
      if (newWindow) newWindow.focus();
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const generateHtmlContent = (data: SectionData[]): string => {
    const sections = data
      .map((item) => {
        const imageRows = [];
        for (let i = 0; i < item.images.length; i += 2) {
          const rowImages = item.images
            .slice(i, i + 2)
            .map(
              (image) => `
                <div class="image">
                  <img src="${image.src}" alt="Section Image" />
                  <p class="caption">${image.caption}</p>
                </div>
              `
            )
            .join("");

          imageRows.push(`<div class="image-row">${rowImages}</div>`);
        }

        return `
          <div class="section">
            <p>Hi</p>
            <p>${item.message}</p>

            <div class="images">
              ${imageRows.join("")}
            </div>
            
            <div class="pdf-icon" onclick="window.generatePDF()">
              <img src="${pdficon}" alt="PDF Icon" />
            </div>
            <div class="banner_img">
              <img src="${item.banner_img}" alt="Banner Image" />
            </div>

            <div class="content">
              <h5>${item.text}</h5>
              <h5>${item.address}</h5>
            </div>
          </div>
        `;
      })
      .join("");

      return `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          body {
            margin: 0;
            padding: 0;
            background-color: #f4f4f4;
            line-height: 1.5;
          }
          .email-container {
            max-width: 800px;
            margin: 20px auto;
            background-color: #ffffff;
            border: 1px solid #003366;
            border-radius: 8px;
            overflow: hidden;
          }
          .header {
            background-color: #003366;
            padding: 20px;
            text-align: center;
            color: white;
          }
          .header img {
            max-width: 100px;
            height: auto;
          }
          .content {
            padding: 20px;
          }
          .content p {
            margin: 0 0 10px;
            color: #333;
          }
          .images {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            justify-content: center;
          }
          .image-row {
            display: flex;
            justify-content: center;
            gap: 20px;
            width: 100%;
          }
          .image {
            flex: 1 1 calc(50% - 20px);
            max-width: calc(50% - 20px);
            text-align: center;
            padding: 10px;

          }
          .image img {
            width: 100%;
            max-width: 200px;
            height: 200px;
            object-fit: cover;
            border-radius: 4px;
            padding: 15px;
            border:1px solid black;
          }
          .caption {
            margin-top: 5px;
            font-size: 14px;
            color: #555;
          }
          .banner_img {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            max-width: 160px;
            height: auto;
            margin: 20px auto;
          }
          .content h5 {
            color: #828485;
            margin: 5px auto;
            padding: 1px;
          }
          .pdf-icon {
            text-align: right;
            padding-right: 0px;
          }
          .pdf-icon img {
            width: 30px;
            height: auto;
          }
          .footer {
            background-color: #f4f4f4;
            padding: 10px;
            text-align: center;
            font-size: 12px;
            color: #888;
          }
          .footer img {
            max-width: 50px;
            margin: 10px auto;
            display: block;
          }

          /* Responsive Styles */
          @media (max-width: 1440px) {
            .email-container {
              max-width: 700px;
            }
            .image img {
              max-width: 180px;
              height: 180px;
            }
          }
          @media (max-width: 1024px) {
            .email-container {
              max-width: 600px;
              padding: 10px;
            }
            .image img {
              max-width: 150px;
              height: 150px;
            }
            .header img {
              max-width: 80px;
            }
          }
          @media (max-width: 768px) {
            .email-container {
              max-width: 100%;
              margin: 10px;
            }
            .image {
              flex: 1 1 100%;
              max-width: 100%;
            }
            .image img {
              max-width: 100%;
              height: auto;
            }
            .header img {
              max-width: 70px;
            }
          }
          @media (max-width: 480px) {
            .header {
              padding: 15px;
            }
            .content {
              padding: 10px;
            }
            .footer p {
              font-size: 10px;
            }
          }
        </style>
      </head>
      <body>
        <div class="email-container">
          <!-- Header -->
          <div class="header">
            <img src="${logo}" alt="ClinicalVisuals Logo">
          </div>

          <!-- Content -->
          <div class="content">
            ${sections}
          </div>

          <!-- Footer -->
          <div class="footer">
            <p>
              If you prefer not to receive emails from Pune Location Name via MotoVisuals you can <br><a href="#">'UNSUBSCRIBE HERE'</a>
            </p>
          </div>
        </div>
      </body>
      </html>

    `;
  };

  // Expose the generateAndOpenPDF function globally for inline event handlers
  window.generatePDF = generateAndOpenPDF;
  

  return (
    <div>
      <div
        ref={htmlRef}
        dangerouslySetInnerHTML={{
          __html: generateHtmlContent(data),
        }}
      />
    </div>
  );
};

export default EmailTemplate;
